import CityPageTemplate from "../city-template/CityPageTemplate";
import { federalHeightsConfig } from "./data";

export default function FederalHeightsPage() {
  return <CityPageTemplate config={federalHeightsConfig} />;
}